import React from 'react';
import { useFormContext } from '@atlassian/jira-issue-create-form-context/src/index.tsx';
import type { IssueRestoreChildren } from '@atlassian/jira-issue-create-restore/src/common/types.tsx';
import { IssueRestore } from '@atlassian/jira-issue-create-restore/src/ui/issue-restore/index.tsx';
import { useTriggerIssueCreateModal } from '@atlassian/jira-packages-controllers-use-trigger-issue-create-modal/src/main.tsx';
import { useIsEmbedded } from '@atlassian/jira-platform-react-hooks-use-is-embedded/src/common/utils/index.tsx';
import { useQueryParam } from '@atlassian/react-resource-router';

export type IssueRestoreWrapperProps = {
	children?: IssueRestoreChildren;
};

export const IssueRestoreWrapper = ({ children }: IssueRestoreWrapperProps) => {
	const [, { restoreState: restoreTriggerIssueCreateModalState }] = useTriggerIssueCreateModal();
	const [, { restoreState: restoreFormContext }] = useFormContext();
	const isEmbedded = useIsEmbedded();
	const [createIncidentModalState] = useQueryParam('open_create_incident_modal');

	const isCreateIncidentModal = createIncidentModalState !== undefined;

	return isEmbedded || isCreateIncidentModal ? (
		<>{children?.({})}</>
	) : (
		<IssueRestore
			onRestoreTriggerIssueCreateModalState={restoreTriggerIssueCreateModalState}
			onRestoreFormContext={restoreFormContext}
		>
			{children}
		</IssueRestore>
	);
};
